export function until(conditionFunction) {
  const poll = resolve => {
    if (conditionFunction()) { resolve(); } else { setTimeout(() => poll(resolve), 250); }
  };
  return new Promise(poll);
}

export default {};
